import { render, staticRenderFns } from "./TrueOrFalseQuestion.vue?vue&type=template&id=b68cddec&"
import script from "./TrueOrFalseQuestion.vue?vue&type=script&lang=js&"
export * from "./TrueOrFalseQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports